<template>
  <div>
    <!-- {{ network }} -->
    <!-- <pre>{{ nwlist }}</pre> -->
    <vs-row
      vs-w="12"
      v-if="
        username == 'frasers.kho' ||
        username == 'frasers.ban' ||
        username == 'frasers.roj' ||
        ['Kendell', 'Endeavor', 'Unicorn', 'JasperW3'].includes(username)
      "
    >
      <vs-card class="roundedCard text-center">
        <div class="mt-2" slot="header">
          <vs-row id="center">
            <h3 class="headerText text-left">Device Map</h3>
            <vs-spacer />
            <!-- <vs-tooltip text="Print" position="top" >
            <vs-button radius   color="#333f50" type="line"   icon="print"></vs-button></vs-tooltip>&nbsp;&nbsp;
            <vs-tooltip text="Download a PDF" position="top" >
              <vs-button radius  color="#333f50" type="line"   icon="picture_as_pdf"></vs-button></vs-tooltip>&nbsp;&nbsp;
              <vs-tooltip text="Export" position="top" >
              <vs-button radius  color="#333f50" type="line"  icon="cloud_download"></vs-button></vs-tooltip>&nbsp;&nbsp;&nbsp;&nbsp; -->
          </vs-row>
        </div>
        <vs-row>
          <vs-col
            ><h4 v-if="network == 'All Location'">No selected location</h4>
            <h4 v-else>{{ network }}</h4>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col v-if="network == 'Endeavor'">
            <img
              class="imgMapFreacer"
              src="@/assets/images/frasers/Moon and Stairs Mystical Logo Template (4).png"
              width="50%"
            />
          </vs-col>
          <vs-col v-if="network == 'Kendell'">
            <img
              class="imgMapFreacer pt-4"
              src="@/assets/images/Freacer/undraw_product_iteration_kjok.png"
              width="50%"
            />
          </vs-col>
          <vs-col v-if="network == 'Unicorn'">
            <img
              class="imgMapFreacer pt-4"
              src="@/assets/images/frasers/mapbangplee.png"
              width="50%"
            />
          </vs-col>
          <vs-col v-if="network == 'JasperW3'">
            <img
              class="imgMapFreacer pt-4"
              src="@/assets/images/frasers/mapJasper.png"
              width="50%"
            />
          </vs-col>
        </vs-row>
      </vs-card>
    </vs-row>
    <vs-row vs-w="12">
      <vs-card style="border-radius: 20px">
        <div class="mt-2" slot="header">
          <vs-row id="center">
            <h3 class="headerText">Download Sensor Data</h3>
            <vs-spacer />
            <!-- <vs-tooltip text="Print" position="top" >
            <vs-button radius   color="#333f50" type="line"   icon="print"></vs-button></vs-tooltip>&nbsp;&nbsp;
            <vs-tooltip text="Download a PDF" position="top" >
              <vs-button radius  color="#333f50" type="line"   icon="picture_as_pdf"></vs-button></vs-tooltip>&nbsp;&nbsp;
              <vs-tooltip text="Export" position="top" >
              <vs-button radius  color="#333f50" type="line"  icon="cloud_download"></vs-button></vs-tooltip>&nbsp;&nbsp;&nbsp;&nbsp; -->
          </vs-row>
        </div>

        <!--Modals download-csv-->
        <b-modal id="bv-modal-example" centered hide-footer>
          <template #modal-title> <h3>Download .csv</h3></template>
          <div
            class="d-block container"
            style="align-items: center; display: flex"
          >
            <b-container class="bv-example-row">
              <b-row>
                <!--startDate-->
                <b-col
                  ><datetime v-model="mintime" input-id="Start Date">
                    <h6 for="startDate" slot="before">StartDate</h6>
                    <span class="description" slot="after"></span>
                    <template slot="button-cancel">
                      <fa :icon="['far', 'times']"></fa>
                      Cancel
                    </template>
                    <template slot="button-confirm"> Confirm </template>
                  </datetime></b-col
                >
                <!--endDate-->
                <b-col
                  ><datetime
                    v-model="maxtime"
                    input-id="startDate"
                    @change="test"
                  >
                    <h6 for="startDate" slot="before">End Date</h6>
                    <span class="description" slot="after"></span>
                    <template slot="button-cancel">
                      <fa :icon="['far', 'times']"></fa>
                      Cancel
                    </template>
                    <template slot="button-confirm"> Confirm </template>
                  </datetime></b-col
                >
                <!-- <b-col><vs-button color="primary" type="border">Primary</vs-button></b-col>-->
              </b-row>
            </b-container>
            <br />

            <vs-button type="filled" color="#333f50" @click="test"
              >Fetch Data</vs-button
            >
            <vs-button type="filled" color="#333f50">
              <download-csv
                :data="sensdata"
                :name="
                  username != 'VSteeldemo'
                    ? sensdata[0].sensorid + ' data.csv'
                    : sensdata[0]['สาขา'] + ' data.csv'
                "
              >
                Download
              </download-csv></vs-button
            >
          </div>
        </b-modal>
        <!--END Modals download-csv-->

        <vs-table
          search
          hoverFlat="false"
          :data="sensorlist"
          style="border-radius: 20px"
        >
          <template slot="header">
            <div
              class="a"
              style="
                margin-left: 1%;
                width: auto;
                margin-top: 1%;
                margin-bottom: 1%;
                border-radius: 5px;
              "
            >
              <vs-dropdown>
                <h6 class="a-icon" href.prevent>
                  Filters :
                  {{ this.network }}
                  <vs-icon class icon="expand_more" size="12px"></vs-icon>
                </h6>
                <vs-dropdown-menu>
                  <vs-dropdown-item
                    v-for="item in nwlist"
                    :key="item.id"
                    @click="actionchange(item.id, item.name)"
                  >
                    {{ item.name }}</vs-dropdown-item
                  >
                </vs-dropdown-menu>
              </vs-dropdown>
              <vs-button
                class="ml-4"
                v-if="username == 'frasers.kho'"
                v-b-modal.allmodal
                ><h6>Download All Sensor Data</h6></vs-button
              >
            </div>
            <vs-spacer />
          </template>
          <br />

          <template slot="thead">
            <vs-th id="noWrap" sort-key="name">
              Sensor Name
              <span><vs-icon icon="unfold_more" size="13px"></vs-icon></span>
            </vs-th>
            <vs-th id="noWrap" sort-key="type">
              Sensor Type
              <span><vs-icon icon="unfold_more" size="13px"></vs-icon></span>
            </vs-th>
            <!-- <vs-th id="noWrap"> Send via E-mail </vs-th> -->
            <vs-th id="noWrap"> Download </vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr
              id="fontSizeData"
              :key="indextr"
              v-for="(tr, indextr) in data"
            >
              <vs-td>
                {{ data[indextr].name }}
              </vs-td>
              <vs-td>
                {{ data[indextr].type }}
              </vs-td>
              <!-- <vs-td>
                  <vs-button
                    color="primary"
                    type="line"
                    icon="cloud_download"
                    id="show-btn"
                    disabled
                    @click="$bvModal.show('bv-modal-example')"
                    >Send via E-mail</vs-button>
                  <vs-button
                    color="primary"
                    type="line"
                    icon="cloud_download"
                    id="show-btn"
                    v-b-modal.sentmail
                    :disabled="true"
                    @click="item2 = data[indextr]"
                    >Send via E-mail</vs-button
                  >
                </vs-td> -->
              <vs-td>
                <vs-button
                  color="warning"
                  type="line"
                  icon="email"
                  id="show-btn"
                  v-b-modal.repdownl
                  @click="item = data[indextr]"
                  >Download .csv</vs-button
                >
                <!-- <vs-button  color="warning" type="line" icon="email" @click="download(data[indextr])">Download .csv</vs-button> -->
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vs-card>
    </vs-row>
    <!-- <iframe src="https://g3.ipcamlive.com/player/player.php?alias=601914ed36f92" width="800px" height="600px" 
frameborder="0" allowfullscreen></iframe> -->
    <vs-prompt
      color="success"
      title="Download .csv"
      type="alert"
      buttonAccept="false"
      buttonCancel="false"
    >
      <div class="d-block container" style="align-items: center; display: flex">
        <b-container class="bv-example-row">
          <b-row>
            <!--startDate-->
            <b-col
              ><datetime v-model="mintime" input-id="Start Date">
                <h6 for="startDate" slot="before">StartDate</h6>
                <span class="description" slot="after"></span>
                <template slot="button-cancel">
                  <fa :icon="['far', 'times']"></fa>
                  Cancel
                </template>
                <template slot="button-confirm"> Confirm </template>
              </datetime></b-col
            >
            <!--endDate-->
            <b-col
              ><datetime v-model="maxtime" input-id="startDate" @change="test">
                <h6 for="startDate" slot="before">End Date</h6>
                <span class="description" slot="after"></span>
                <template slot="button-cancel">
                  <fa :icon="['far', 'times']"></fa>
                  Cancel
                </template>
                <template slot="button-confirm"> Confirm </template>
              </datetime></b-col
            >
            <!-- <b-col><vs-button color="primary" type="border">Primary</vs-button></b-col>-->
          </b-row>
        </b-container>
        <br />
        <vs-button type="filled" @click="test" color="#333f50">Fetch</vs-button>
        <vs-button
          type="filled"
          color="#333f50"
          class="ml-2"
          :disabled="!sensdata[1]"
        >
          <download-csv
            :data="sensdata"
            :name="item.name + ' ' + date + ' data.csv'"
          >
            Download
          </download-csv></vs-button
        >
      </div>
    </vs-prompt>

    <!-- sendmail -->
    <b-modal
      id="sentmail"
      no-close-on-backdrop="false"
      ref="sentmail"
      hide-header-close
      centered
      hide-footer
      size="lg"
    >
      <template #modal-title>
        <h4 style="color: #5fa74b">Send via E-mail</h4>
      </template>
      <vs-row class="mt-2" vs-w="12">
        <vs-col
          vs-type="flex"
          vs-align="center"
          vs-lg="6"
          vs-sm="12"
          vs-xs="12"
        >
          Start Date :
          <div style="padding: 20px; padding-left: 14px">
            <datetime
              v-model="mintime2"
              input-id="Start Date"
              class="theme-orange"
              type="datetime"
            />
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-align="center"
          vs-lg="6"
          vs-sm="12"
          vs-xs="12"
        >
          End Date :
          <div style="padding: 20px; padding-left: 20px">
            <datetime
              class="glyphicon glyphicon-cloud"
              v-model="maxtime2"
              input-id="startDate"
              type="datetime"
            />
          </div>
        </vs-col>
      </vs-row>
      <vs-row vs-w="12">
        <vs-col
          vs-type="flex"
          vs-align="center"
          vs-lg="12"
          vs-sm="12"
          vs-xs="12"
        >
        </vs-col> </vs-row
      ><br />

      <vs-row class="ml-3 mt-2" vs-w="12">
        <vs-spacer />
        <vs-button
          :disabled="active == true"
          style="border-radius: 18px"
          color="warning"
          @click="sentmail()"
          icon="search"
          type="filled"
          >Send E-mail</vs-button
        >
        <vs-button
          class="ml-2 mr-4"
          color="dark"
          type="flat"
          id="btncancel"
          @click="cancel()"
          >Cancel</vs-button
        >
      </vs-row>
    </b-modal>
    <b-modal
      id="repdownl"
      no-close-on-backdrop="false"
      hide-header-close
      centered
      hide-footer
      size="lg"
    >
      <template #modal-title>
        <h4 style="color: #5fa74b">Download .csv</h4>
      </template>
      <vs-row class="mt-2" vs-w="12">
        <vs-col
          vs-type="flex"
          vs-align="center"
          vs-lg="5"
          vs-sm="12"
          vs-xs="12"
        >
          Start Date :
          <div style="padding: 20px; padding-left: 14px">
            <datetime
              v-model="mintime"
              input-id="Start Date"
              class="theme-orange"
              type="datetime"
            />
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-align="center"
          vs-lg="5"
          vs-sm="12"
          vs-xs="12"
        >
          End Date :
          <div style="padding: 20px; padding-left: 20px">
            <datetime
              class="glyphicon glyphicon-cloud"
              v-model="maxtime"
              input-id="startDate"
              type="datetime"
            />
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-align="center"
          vs-lg="2"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-button
            :disabled="active == true"
            style="border-radius: 18px"
            color="warning"
            @click="checkDownload()"
            icon="search"
            type="filled"
            >Check</vs-button
          >
        </vs-col> </vs-row
      ><br />

      <vs-row v-if="active == true" vs-w="12">
        <vs-col class="mt-2" vs-type="flex" vs-lg="2" vs-sm="12" vs-xs="12">
          Download .csv
        </vs-col>
        <vs-col vs-type="flex" vs-lg="8" vs-sm="12" vs-xs="12">
          <vs-col class="mt-2"
            >Start Date :
            {{ $moment(mintime).format("YYYY-MM-DD HH:mm:ss") }}
            <vs-col class="mt-2"
              >Due Date :
              {{ $moment(maxtime).format("YYYY-MM-DD HH:mm:ss") }}</vs-col
            >
          </vs-col>
        </vs-col> </vs-row
      ><br />

      <vs-row class="ml-3 mt-3" vs-w="12">
        <vs-spacer />
        <vs-button
          @click="hidemodal()"
          v-if="active == true"
          :disabled="!sensdata[1]"
          style="border-radius: 18px"
          color="primary"
          type="filled"
        >
          <download-csv
            :data="sensdata"
            :name="item.name + ' ' + date + ' data.csv'"
          >
            Download
          </download-csv></vs-button
        >
        <vs-button
          class="ml-2 mr-4"
          color="dark"
          type="flat"
          id="btncancel"
          @click="hidemodal()"
          :style="{ color: 'var(--text-color)' }"
          >Cancel</vs-button
        >
      </vs-row>
    </b-modal>

    <b-modal
      id="allmodal"
      no-close-on-backdrop="false"
      hide-header-close
      centered
      hide-footer
      size="lg"
    >
      <template #modal-title>
        <h4 style="color: #5fa74b">Download .csv</h4>
      </template>
      <vs-row class="mt-2" vs-w="12">
        <vs-col
          vs-type="flex"
          vs-align="center"
          vs-lg="5"
          vs-sm="12"
          vs-xs="12"
        >
          Start Date :
          <div style="padding: 20px; padding-left: 14px">
            <datetime
              v-model="mintime"
              input-id="Start Date"
              class="theme-orange"
              type="datetime"
            />
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-align="center"
          vs-lg="5"
          vs-sm="12"
          vs-xs="12"
        >
          End Date :
          <div style="padding: 20px; padding-left: 20px">
            <datetime
              class="glyphicon glyphicon-cloud"
              v-model="maxtime"
              input-id="startDate"
              type="datetime"
            />
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-align="center"
          vs-lg="2"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-button
            :disabled="active == true"
            style="border-radius: 18px"
            color="warning"
            @click="checkAllDownload()"
            icon="search"
            type="filled"
            >Check</vs-button
          >
        </vs-col> </vs-row
      ><br />

      <vs-row v-if="active == true" vs-w="12">
        <vs-col class="mt-2" vs-type="flex" vs-lg="2" vs-sm="12" vs-xs="12">
          Download .csv
        </vs-col>
        <vs-col vs-type="flex" vs-lg="8" vs-sm="12" vs-xs="12">
          <vs-col class="mt-2"
            >Start Date :
            {{ $moment(mintime).format("YYYY-MM-DD HH:mm:ss") }}
            <vs-col class="mt-2"
              >Due Date :
              {{ $moment(maxtime).format("YYYY-MM-DD HH:mm:ss") }}</vs-col
            >
          </vs-col>
        </vs-col> </vs-row
      ><br />

      <vs-row class="ml-3 mt-3" vs-w="12">
        <vs-spacer />
        <vs-button
          @click="hideallmodal()"
          v-if="active == true"
          :disabled="!sensdata[1]"
          style="border-radius: 18px"
          color="primary"
          type="filled"
        >
          <download-csv
            :data="sensdata"
            :name="network + ' ' + date + ' data.csv'"
          >
            Download
          </download-csv></vs-button
        >
        <vs-button
          class="ml-2 mr-4"
          color="dark"
          type="flat"
          id="btncancel"
          @click="hideallmodal()"
          :style="{ color: 'var(--text-color)' }"
          >Cancel</vs-button
        >
      </vs-row>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "Report",
  data: () => ({
    item: { name: "test" },
    nwlist: [],
    admin: '',
    frasers_user: ["Kendell", "Endeavor", "Unicorn", "JasperW3"],
    users_item: [
      {
        name: "Kendell",
        id: 115,
        sc: 46,
        gwc: 1,
        value: "KhonKaen Warehouse",
      },
      {
        name: "Endeavor",
        id: 145,
        sc: 57,
        gwc: 1,
        value: "Rojana Warehouse",
      },
      {
        name: "Unicorn",
        id: 146,
        sc: 42,
        gwc: 1,
        value: "Bangplee Warehouse",
      },
      {
        value: "JasperW3 Warehouse",
        id: 168,
        sc: 2,
        gwc: 1,
        name: "JasperW3",
      },
      // {
      //   id: 5,
      //   name: "Jasper W1",
      //   path: "/customdashboardJasperW1",
      //   user: "JasperW1",
      // },
    ],
    reportdownload: "",
    sensorlist: [],
    fields: ["id", "test"],
    network: "",
    sensdata: [{ sensorid: "" }],
    active: false,
    active2: false,
    mintime: null,
    maxtime: null,
    mintime2: null,
    maxtime2: null,
    value: "",
    date: "",
    username: "",
    mockupData: [
      {
        timestamp: "2021-12-21 16:00:00",
        pm25: 20.1,
        pm10: 55.3,
        temp: 27.8,
        humid: 67.7,
        windspeed: 0.0,
        winddirection: "N",
        quailty: "Normal",
      },
      {
        timestamp: "2021-12-21 16:05:00",
        pm25: 19.5,
        pm10: 51.7,
        temp: 27.7,
        humid: 69.0,
        windspeed: 0.0,
        winddirection: "N",
        quailty: "Normal",
      },
      {
        timestamp: "2021-12-21 16:10:00",
        pm25: 17.8,
        pm10: 49.9,
        temp: 27.6,
        humid: 68.3,
        windspeed: 1.0,
        winddirection: "NW",
        quailty: "Normal",
      },
      {
        timestamp: "2021-12-21 16:15:00",
        pm25: 15.0,
        pm10: 47.6,
        temp: 27.3,
        humid: 67.1,
        windspeed: 1.1,
        winddirection: "NW",
        quailty: "Good",
      },
      {
        timestamp: "2021-12-21 16:25:00",
        pm25: 14.8,
        pm10: 46.1,
        temp: 28.5,
        humid: 65.3,
        windspeed: 0.9,
        winddirection: "W",
        quailty: "Good",
      },
      {
        timestamp: "2021-12-21 16:30:00",
        pm25: 15.6,
        pm10: 48.0,
        temp: 29.1,
        humid: 66.8,
        windspeed: 0.5,
        winddirection: "W",
        quailty: "Good",
      },
      {
        timestamp: "2021-12-21 16:35:00",
        pm25: 16.7,
        pm10: 50.6,
        temp: 27.8,
        humid: 68.1,
        windspeed: 0.0,
        winddirection: "W",
        quailty: "Normal",
      },
      {
        timestamp: "2021-12-21 16:40:00",
        pm25: 19.0,
        pm10: 53.4,
        temp: 25.0,
        humid: 70.0,
        windspeed: 0.3,
        winddirection: "S",
        quailty: "Normal",
      },
      {
        timestamp: "2021-12-21 16:45:00",
        pm25: 22.5,
        pm10: 57.8,
        temp: 24.6,
        humid: 68.5,
        windspeed: 0.2,
        winddirection: "S",
        quailty: "Bad",
      },
    ],
  }),

  methods: {
    downloadAll() {
      var body = {
        column: "*",
        start: this.mintime,
        end: this.maxtime,
        id: this.item.serial_id,
        type: this.item.type,
        gid: this.item.gatewayid,
        lora: this.item.lora,
        mode: "report",
      };
      this.$API.post("report/frasers", body).then((result) => {
        console.log(result.data);
        // this.sensdata = []
        // result.data.forEach(element => {
        //   splitName = element.name.split('_')
        //   splitLocation = splitName[1]
        //   console.log(splitName)
        //   this.sensdata.push({
        //     Location: splitName[0],
        //     Area: splitName[2],
        //     Name: splitName[1],
        //     Humidity: element.humidity,
        //     Temperature: element.temperature,
        //     Time: this.$moment(this.$moment(element.time).add('7','hours')).format('HH:mm:ss'),
        //     Date: this.$moment(this.$moment(element.time).add('7','hours')).format('YY/MM/DD')
        //   })
        // });
      });
      console.log(this.network);
    },
    hidemodal() {
      this.$bvModal.hide("repdownl");
      this.mintime = "";
      this.maxtime = "";
      this.active = false;
      this.sensdata = [{ sensorid: "" }];
    },
    hideallmodal() {
      this.$bvModal.hide("allmodal");
      this.mintime = "";
      this.maxtime = "";
      this.active = false;
      this.sensdata = [{ sensorid: "" }];
    },
    cancel() {
      location.reload();
    },
    sentmail() {
      // // console.log('hi')
      // // this.sendMailUrl = "emailreport/" +this.item2.username +"/" + this.item2.type+"/"+ this.item2.serial_id+"/"+this.mintime2+"/"+this.maxtime2
      // this.$API.get("emailreport/" +this.item2.username +"/" + this.item2.type+"/"+ this.item2.serial_id+"/"+this.mintime2+"/"+this.maxtime2).then(response){
      // // console.log(response)
      // }

      //  this.$refs['sentmail'].hide()
      this.$API
        .get(
          "emailreport/" +
            this.item2.type +
            "/" +
            this.item2.serial_id +
            "/" +
            this.mintime2 +
            "/" +
            this.maxtime2,
          {
            headers: {
              "Access-Control-Request-Method": "*",
              "Access-Control-Request-Headers": "*",
              "Access-Control-Allow-Origin": "*",
            },
            username: "admin",
            password: "admin",
            role: this.checkbox,
          }
        )
        .then((result) => {
          // console.log(result);
          if (result.status == 200) {
            this.$vs.notify({
              time: 3000,
              title: "Icon mail",
              text: "Lorem ipsum dolor sit amet, consectetur",
              color: "success",
              icon: "email",
              position: "top-center",
            });
            this.$refs["sentmail"].hide();
            // console.log("Email")
          }
        });
    },

    //   {
    //   headers: {
    //     'Access-Control-Request-Method': '*',
    //     'Access-Control-Request-Headers': '*',
    //     'Access-Control-Allow-Origin': '*'
    //   },
    //   username: "admin",
    //   password: "admin",
    //   role: this.checkbox
    //   }).then((result) =>{
    //     // console.log(result);
    //     // console.log("done")
    //   })
    // },
    checkDownload() {
      var splitName = "";
      var splitLocation = "";
      if (this.username == "") {
        this.sensdata = this.mockupData;
        this.active = true;
      } else if (this.maxtime == "" || this.mintime == "") {
        this.$vs.loading();
        // // console.log('hi')
        this.$API
          .get("sensordata2/" + this.item.serial_id + "/" + this.item.gatewayid)
          .then((result) => {
            // eslint-disable-next-line no-console
            console.log(result.data);
            console.log(this.username);
            this.sensdata = result.data;
            this.active = true;
            this.$vs.loading.close();
          });
      } else {
        var body = {
          column: "*",
          start: this.mintime,
          end: this.maxtime,
          id: this.item.serial_id,
          type: this.item.type,
          gid: this.item.gatewayid,
          lora: this.item.lora,
          mode: "report",
        };
        // console.log(body);
        if (this.username == "frasers.kho" || this.admin == "Galaxy" || this.username == "Galaxy") {
          this.$vs.loading();
          this.$API.post("filtersensor", body).then((result) => {
            console.log(result.data);
            this.sensdata = [];
            result.data.forEach((element) => {
              splitName = element.name.split("_");
              splitLocation = splitName[1];
              // console.log(splitName)
              this.sensdata.push({
                Location: splitName[0],
                Area: splitName[2] || "Outside",
                Name: splitName[1],
                Serial_ID: element.serial_id,
                Humidity: element.humidity,
                Temperature: element.temperature,
                Time: this.$moment(element.time).format("HH:mm:ss"),
                Date: this.$moment(element.time).format("DD-MM-YYYY"),
              });
            });
            this.active = true;
            this.$vs.loading.close();
          });
        } else {
          this.$vs.loading();
          this.$API.post("filtersensor", body).then((result) => {
            // eslint-disable-next-line no-console
            console.log(result.data);
            // console.log(this.username);
            this.sensdata = result.data;
            this.active = true;
            this.$vs.loading.close();
          });
        }
      }
    },
    checkAllDownload() {
      console.log(this.item);
      var splitName = "";
      var splitLocation = "";
      this.$vs.loading();
      var body = {
        start: this.mintime,
        end: this.maxtime,
        network: this.network,
        mode: "report",
      };
      console.log(body);
      this.$API
        .post("report/frasers", body)
        .then((result) => {
          console.log(result.data);
          this.sensdata = [];
          result.data.forEach((element) => {
            splitName = element.name.split("_");
            splitLocation = splitName[1];
            // console.log(splitName)
            this.sensdata.push({
              Location: splitName[0],
              Area: splitName[2] || "Outside",
              Name: splitName[1],
              Serial_ID: element.serial_id,
              Humidity: element.humidity,
              Temperature: element.temperature,
              Time: this.$moment(
                this.$moment(element.time).add("7", "hours")
              ).format("HH:mm:ss"),
              Date: this.$moment(
                this.$moment(element.time).add("7", "hours")
              ).format("DD-MM-YYYY"),
            });
          });
        })
        .then(() => {
          this.active = true;
          this.$vs.loading.close();
        });
    },
    async actionchange(id, name) {
      this.network = name;
      if (name == "All Location") {
        await this.$API.get("sensors/user").then((result) => {
          this.sensorlist = result.data;
        });
      } else {
        await this.$API.get("sensor/user/network/" + id).then((result) => {
          // console.log('Sensor', id, result)
          this.sensorlist = result.data;
        });
      }
      // eslint-disable-next-line no-console
      // console.log(this.sensorlist);
    },
    link2(item) {
      this.$router.push({
        name: "SensorDashboard",
        params: {
          nwname: this.network,
          nwid: item.nwid,
          sensorid: item.serial_id,
          gatewayid: item.gatewayid,
          type: item.type,
        },
      });
    },
    download(item) {
      this.item = item;
      this.active = true;
      // if(this.maxtime == '' || this.mintime == '') {
      //   // console.log('hi')
      //   this.$API.get('sensor/1/serial-id/'+item.serial_id+'/'+item.gatewayid).then((result) => {
      //   // eslint-disable-next-line no-console
      //     // console.log(result.data)
      //     this.sensdata = result.data
      //   }).then(() => {
      //     this.active = true
      //   })
      // }else{
      //   var body = {
      //     column: "*",
      //     start: this.mintime,
      //     end: this.maxtime,
      //     id: item.serial_id,
      //     type: item.type,
      //     gid: item.gatewayid,
      //     mode: 'report'
      //   }
      //   // console.log(body)
      //   this.$API.post('filtersensor', body).then((result) => {
      //   // eslint-disable-next-line no-console
      //     // console.log(result.data)
      //     this.sensdata = result.data
      //   }).then(() => {
      //     this.active = true
      //   })
      // }
    },
    defaultuser_callreport() {
      this.$API.get("network/user").then((result) => {
        this.nwlist = result.data;
        this.nwlist.forEach((element) => {
          if (element.name == "KhonKaen Warehouse") {
            element.value = "KhonKaen Warehouse";
            element.name = "Kendall";
          } else if (element.name == "Rojana Warehouse") {
            element.value = "Rojana Warehouse";
            element.name = "Endeavor";
          } else if (element.name == "Bangplee Warehouse") {
            element.value = "Bangplee Warehouse";
            element.name = "Unicorn";
          } else if (element.name == "JasperW3 Warehouse") {
            element.value = "JasperW3 Warehouse";
            element.name = "JasperW3";
          }
        });
        this.nwlist.unshift({
          id: 0,
          name: "All Location",
          value: "All Location",
        });
        this.network = result.data[0].name;
        console.log(this.nwlist);
      });
      if (this.username == "") {
        this.sensorlist = [{ name: "Sensor", type: "LoRa" }];
      } else {
        this.$API.get("sensors/user").then((result) => {
          this.sensorlist = result.data;
        });
      }
    },
    async frasers_callreport() {
      await this.$API.get("network/user").then((result) => {
        if (this.frasers_user.includes(this.username)) {
          this.users_item.forEach((item) => {
            if (this.username == item.name) {
              this.nwlist.push(item);
              this.actionchange(item.id, item.name);
            }
          });
        } else {
          this.nwlist.unshift({
            id: 0,
            name: "All Location",
            value: "All Location",
          });
          this.nwlist = result.data;
          this.network = result.data[0].name;

          this.$API.get("sensors/user").then((result) => {
            this.sensorlist = result.data;
          });
        }

        this.nwlist.forEach((element) => {
          if (element.name == "KhonKaen Warehouse") {
            element.value = "KhonKaen Warehouse";
            element.name = "Kendell";
          } else if (element.name == "Rojana Warehouse") {
            element.value = "Rojana Warehouse";
            element.name = "Endeavor";
          } else if (element.name == "Bangplee Warehouse") {
            element.value = "Bangplee Warehouse";
            element.name = "Unicorn";
          } else if (element.name == "JasperW3 Warehouse") {
            element.value = "JasperW3 Warehouse";
            element.name = "JasperW3";
          }
        });
      });
    },
  },
  // created() {
  //   this.username = this.$session.get("username");
  //   this.date = this.$moment().format("YYYY-MM-DD HH:mm:ss");
  //   this.$API.get("network/user").then((result) => {
  //     if (this.frasers_user.includes(this.username)) {
  //       this.users_item.forEach((item) => {
  //         if (this.username == item.name) {
  //           this.nwlist.push(item);
  //           this.actionchange(item.id, item.name);
  //         }
  //       });
  //     } else {
  //       this.nwlist.unshift({
  //         id: 0,
  //         name: "All Location",
  //         value: "All Location",
  //       });
  //       this.nwlist = result.data;
  //       this.network = result.data[0].name;
  //     }

  //     this.nwlist.forEach((element) => {
  //       if (element.name == "KhonKaen Warehouse") {
  //         element.value = "KhonKaen Warehouse";
  //         element.name = "Kendell";
  //       } else if (element.name == "Rojana Warehouse") {
  //         element.value = "Rojana Warehouse";
  //         element.name = "Endeavor";
  //       } else if (element.name == "Bangplee Warehouse") {
  //         element.value = "Bangplee Warehouse";
  //         element.name = "Unicorn";
  //       } else if (element.name == "JasperW3 Warehouse") {
  //         element.value = "JasperW3 Warehouse";
  //         element.name = "JasperW3";
  //       }
  //     });
  //   });

  //   if (this.username == "") {
  //     this.sensorlist = [{ name: "Sensor", type: "LoRa" }];
  //   } else {
  //     this.$API.get("sensors/user").then((result) => {
  //       this.sensorlist = result.data;
  //     });
  //   }
  // },
  created() {
    this.username = this.$session.get("username");
    this.admin = this.$session.get('admin')
    this.date = this.$moment().format("YYYY-MM-DD HH:mm:ss");

    if (this.frasers_user.includes(this.username)) {
      this.frasers_callreport();
    } else {
      this.defaultuser_callreport();
    }
  },
  computed: {},
};
</script>
<style scoped>
.headerText {
  color: var(--text-color);
}
.roundedCard {
  border-radius: 20px;
}
#noWrap {
  white-space: nowrap;
  padding: 0px;
  font-size: 0.75rem;
}
#show-btn {
  white-space: nowrap;
  font-size: 0.75rem;
}
input.vdatetime-input {
  border: none;
  padding-left: 10%;
  border-bottom: 1px solid black;
}
#btncancel {
  background-color: #ffffff;
  border-radius: 20px;
  border-color: #ffffff;
}

button#dropdown-1_BV_toggle_.btn.dropdown-toggle.btn-secondary {
  border-radius: 5px;
}
th .sort-th .th-sort-icon {
  color: white;
  padding: 0px;
}
#center {
  display: flex;
  align-items: center;
}
#p {
  display: inline;
}
#v {
  display: none;
}
@media screen and (max-width: 600px) {
  .a {
    /* background: pink; */
    width: 200px;
  }
  #v {
    display: inline;
  }
  #p {
    display: none;
  }
  .vuesax-app-is-ltr .vs-table--search-input {
    width: 100px;
    padding: o;
  }
  .vuesax-app-is-ltr .vs-table--search i {
    left: 15px;
  }
}
</style>
